import { faChevronRight } from "@fortawesome/pro-solid-svg-icons/faChevronRight";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link, useMatches } from "react-router";

import type { BreadcrumbsProps } from "../types/components/BreadcrumbsProps";

import "../assets/scss/components/_breadcrumbs.scss";
import { SlugToName } from "../utilities/StringUtils";

export const Breadcrumbs = ({ productName }: BreadcrumbsProps) => {
	const matches = useMatches();

	const categorySlug = matches.find((match) => match.id === "routes/url-handler")?.params?.type;
	const categoryName = categorySlug ? SlugToName(categorySlug) : null;

	if (!categorySlug || !categoryName) {
		// return null;
	}

	return (
		<div className="breadcrumbs">
			<Link to="/">
				Home <FontAwesomeIcon icon={faChevronRight} />
			</Link>

			{categorySlug && categoryName && (
				<Link to={`/${categorySlug}`}>
					{categoryName} <FontAwesomeIcon icon={faChevronRight} />
				</Link>
			)}

			<span>{productName ?? "    "}</span>
		</div>
	);
};
